module.exports = __webpack_public_path__ + "static/media/postman.7571f060.png";